































import { Component, Emit, Vue } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';
import { InviteOrganizationMemberDto } from '@/@types/Organization';
import { vxm } from '@/store';

@Component({
  components: {
    CommonButton,
  },
})
export default class ProjectInviteMenu extends Vue {
  private inviteOrganizationMemberDto: InviteOrganizationMemberDto = {
    organizationId: vxm.theoryApi.authStore.getCurrentOrganizationId ?? 0,
    email: '',
    organizationAdministratorFlag: false,
  }

  @Emit('closeInviteMenu')
  private closeInviteMenu() {
    return;
  }

  @Emit('inviteMember')
  private inviteMember() {
    return this.inviteOrganizationMemberDto;
  }
}
